// function to replace long string with ... based on string length value
export const displayEllipticalString = (string, stringLength) => {
  return string.slice(0, stringLength).concat('...')
}
// function to check if a string has number in it
export const hasNumber = (string) => {
  return /\d/.test(string)
}
// convert date from mm-dd-yy to Month Date, Year
export const getDate = (value) => {
  const date = value.split(' ').slice(-1)
  const res = date.toString().replace(/-/g, '/')
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const now = new Date(res)
  return `${months[now.getMonth()]} ${now.getDate()}, ${now.getFullYear()}`
}